import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Components/Header/Header";
import "bootstrap/dist/css/bootstrap.min.css";
import Home from "./Components/Home/Home";
import Contact from "./Components/Contact/Contact";
import About from "./Components/About/About";
import Gallery from "./Components/Gallery/Gallery";
import Services from "./Components/Services/Services";
import Special from "./Components/Servicelist/SpecialEducation/Special";
import Footer from "./Components/Footer/Footer"
import Physiotherapy from "./Components/Servicelist/Physiotherapy/Physiotherapy";
import  Speech  from "../src/Components/Servicelist/SpeechTherapy/Speech";
import Occupational from "../src/Components/Servicelist/OccupationalTherapy/Occupational"
import Creative from "./Components/Servicelist/CreativePlay/Creative";
import Mathrudeepti from "./Components/Servicelist/Mathrudeepti/Mathrudeepti";
import Vocational from "./Components/Servicelist/VocationalTraining/Vocational";
import Counselling from "./Components/Servicelist/Counselling/Counselling"
import Workshop from "./Components/Servicelist/Workshop/Workshop";
import Events from "./Components/Events/Events";
import Admission from "./Components/Admission/Admission";
import Donate from "./Components/Donate/Donate"
import Socialmedia from "./Components/Socialmedia/Socailmedia";
import BookAppointmentButton from "./Components/BookNow/Book"


function App() {
  return (
    <Router>
      <Header />
      <Socialmedia/>
      <div style={{marginTop:"150px"}}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/reach-us" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/services" element={<Services />} />
        <Route path="/special-education" element={<Special />} />
        <Route path="/physiotherapy" element={<Physiotherapy />} />
        <Route path="/speech-therapy" element={<Speech />} />
        <Route path="/occupational-Therapy" element={<Occupational/>} />
        <Route path="/creative-play" element={<Creative/>} />
        <Route path="/vocational-training" element={<Vocational/>}/>
        <Route path="/mathrudeepti" element={<Mathrudeepti/>}/>
        <Route path="/counselling" element={<Counselling/>}/>
        <Route path="/workshops" element={<Workshop/>}/>
        <Route path="/admission" element={<Admission/>}/>
        <Route path="/events" element={<Events/>}/>
        <Route path="/donate" element={<Donate/>}/>


      </Routes>
      </div>
      <BookAppointmentButton />
      <Footer/>
    </Router>
    
  );
}

export default App;
